import React from 'react';
import { SuccessScene } from '../../components/SuccessScene';

export const ResetPasswordSuccessScene = () => <SuccessScene context="ResetPasswordSuccessScene" />;
